import actions from './actions'

const default_report = {
    fid: 0,
    title: "",
    content: "",
    create_time: 0,
    deleted: false,
    event: [
    ],
    hashtag: [
    ],
    media: [
    ],
    object: [
    ],
    related_data_id: [
    ],
    organ_create: 0,
    owner_id: 0,
    receiver_uid: [
    ],
    uid_has_read: [
    ],
    tier_created: 0
}

const initState = {
    reports: [],
    tier_select: 0,
    history_reports: [],

    // current report info
    mode_modal_report_info: 'View',
    current_report: default_report,
    current_comment: "",
    is_select_report_tier: true,

    // list lower tier
    textSearch: "",
    begin_time: null,
    end_time: null,
    isLoading: false,
    lastTextSearch: "",

    // list history report
    history_textSearch: "",
    history_begin_time: null,
    history_end_time: null,
    history_isLoading: false,
    history_lastTextSearch: "",
    history_status: "Existed", // "Existed", "Creating", "Send"

    // paginate
    pageSize: 8,
    pageIndex: 1,
    total: 0,

    history_pageSize: 6,
    history_pageIndex: 1,
    history_total: 0,

    // modal state
    modalReportInfoState: false,
    modalSelectMediaState: false,
    modalSelectObjectState: false,
    modalSelectEventState: false,
    modalSelectReportLowerTierState: false,

    // select entity
    selected_Media: [],
    selected_object: [],
    selected_event: [],
    selected_report: [],
    comments: [],

    // hash tag
    hashtag: []
}

const _handleAddHashTag = (state, hashtag) => {
    let ok = true 
    
    let hashtags = state.hashtag 
    for(let index = 0; index < hashtags.length; index++)
        if (hashtags[index] === hashtag)
            ok = false 

    if (!ok) return state
    hashtags.push(hashtag)

    return {
        ...state,
        ...{
            hashtag: hashtags
        }
    }
}

const _handleDeleteHashtag = (state, hashtag) => {
    let new_hashtags = []
    let hashtags = state.hashtag

    for(let index = 0; index < hashtags.length; index++)
        if (hashtags[index] !== hashtag)
            new_hashtags.push(hashtags[index])

    return {
        ...state,
        ...{
            hashtag: new_hashtags
        }
    }
}

const reportReducer = (state = initState, action) => {
    switch (action.type) {
        case actions.type.UPDATE_STATE:
            return {
                ...state,
                ...action.payload.state
            }

        case actions.type.SET_INIT_STATE:
            return initState

        // list report tab
        case actions.type.LOAD_LIST_REPORTS:
            return {
                ...state,
                ...{
                    isLoading: true
                }
            }

        case actions.type.LOAD_LIST_REPORT_SUCCESS:
            return {
                ...state,
                ...{
                    reports: action.payload.reports,
                    isLoading: false
                }
            }

        case actions.type.USER_CHANGE_SELECT_TIER:
            return {
                ...state,
                ...{
                    tier_select: action.payload.tier,
                    pageIndex: 1,
                }
            }

        case actions.type.UPDATE_TEXT_SEARCH:
            return {
                ...state,
                ...{
                    textSearch: action.payload.textSearch
                }
            }

        case actions.type.SEARCH_REPORT:
            return {
                ...state,
                ...{
                    lastTextSearch: state.textSearch
                }
            }

        case actions.type.UPDATE_TIME:
            return {
                ...state,
                ...{
                    begin_time: action.payload.begin_time,
                    end_time: action.payload.end_time
                }
            }

        case actions.type.UPDATE_PAGE_SIZE:
            return {
                ...state,
                ...{
                    pageSize: action.payload.pageSize,
                    pageIndex: 1
                }
            }

        case actions.type.UPDATE_PAGE_INDEX:
            return {
                ...state,
                ...{
                    pageIndex: action.payload.pageIndex
                }
            }

        // history tab 
        case actions.type.LOAD_LIST_HISTORY_REPORTS:
            return {
                ...state,
                ...{
                    history_isLoading: true
                }
            }

        case actions.type.LOAD_LIST_HISTORY_REPORTS_SUCCESS:
            return {
                ...state,
                ...{
                    history_reports: action.payload.history_reports,
                    history_isLoading: false
                }
            }

        case actions.type.UPDATE_HISTORY_TEXT_SEARCH:
            return {
                ...state,
                ...{
                    history_textSearch: action.payload.textSearch
                }
            }

        case actions.type.SEARCH_HISTORY_REPORT:
            return {
                ...state,
                ...{
                    history_lastTextSearch: state.history_textSearch
                }
            }

        case actions.type.UPDATE_HISTORY_TIME:
            return {
                ...state,
                ...{
                    history_begin_time: action.payload.begin_time,
                    history_end_time: action.payload.end_time
                }
            }

        case actions.type.UPDATE_HISTORY_PAGE_SIZE:
            return {
                ...state,
                ...{
                    history_pageSize: action.payload.pageSize,
                    history_pageIndex: 1
                }
            }

        case actions.type.UPDATE_HISTORY_PAGE_INDEX:
            return {
                ...state,
                ...{
                    history_pageIndex: action.payload.pageIndex
                }
            }

        case actions.type.USER_CHANGE_HISTORY_SELECT_STATUS:
            return {
                ...state,
                ...{
                    history_status: action.payload.status,
                    history_pageIndex: 1
                }
            }

        // report info 
        case actions.type.SET_CURRENT_REPORT:
            return {
                ...state,
                ...{
                    current_report: action.payload.report,
                    is_select_report_tier: false,
                    selected_Media: [],
                    selected_object: [],
                    selected_event: [],
                    selected_report: [],
                    comments: [],
                    hashtag: []
                }
            }

        case actions.type.SET_DEFAULT_CURRENT_REPORT:
            return {
                ...state,
                ...{
                    current_report: {
                        ...default_report,
                        ...{
                            owner: action.payload.userInfo,
                            tier_created: (action.payload.userInfo.tier_id >=1 && action.payload.userInfo.tier_id <= 3) 
                                            ? action.payload.userInfo.tier_id
                                            : 1
                        }
                    },
                    is_select_report_tier: (action.payload.userInfo.tier_id >=1 && action.payload.userInfo.tier_id <= 3) 
                                            ? false
                                            : true,
                    selected_Media: [],
                    selected_object: [],
                    selected_event: [],
                    selected_report: [],
                    comments: [],
                    hashtag: []
                }
            }

        case actions.type.UPDATE_CURRENT_REPORT:
            return {
                ...state,
                ...{
                    current_report: {
                        ...state.current_report,
                        ...action.payload.report
                    }
                }
            }

        case actions.type.SAVE_CURRENT_REPORT:
            return state

        case actions.type.SHOW_MODAL_REPORT_INFO:
            return {
                ...state,
                ...{
                    modalReportInfoState: true
                }
            }

        case actions.type.DISMISS_MODAL_REPORT_INFO:
            return {
                ...state,
                ...{
                    modalReportInfoState: false
                }
            }

        // hash tag 
        case actions.type.ADD_HASH_TAG:
            return _handleAddHashTag(state, action.payload.hashtag)

        case actions.type.DELETE_HASH_TAG:
            return _handleDeleteHashtag(state, action.payload.hashtag)

        // comment 
        case actions.type.ADD_COMMENT:
            return state

        case actions.type.UPDATE_CURRENT_COMMENT:
            return {
                ...state,
                ...{
                    current_comment: action.payload.comment
                }
            }

        // select media
        case actions.type.LOAD_LIST_SELECTED_MEDIA:
            return state

        case actions.type.SHOW_MODAL_SELECT_MEDIA:
            return {
                ...state,
                ...{
                    modalSelectMediaState: true
                }
            }

        case actions.type.DISMISS_MODAL_SELECT_MEDIA:
            return {
                ...state,
                ...{
                    modalSelectMediaState: false
                }
            }

        case actions.type.UPDATE_SELECTED_MEDIA:
            return {
                ...state,
                ...{
                    selected_Media: action.payload.selected_Media
                }
            }

        // select object
        case actions.type.LOAD_LIST_SELECTED_OBJECT:
            return state

        case actions.type.SHOW_MODAL_SELECT_OBJECT:
            return {
                ...state,
                ...{
                    modalSelectObjectState: true
                }
            }

        case actions.type.DISMISS_MODAL_SELECT_OBJECT:
            return {
                ...state,
                ...{
                    modalSelectObjectState: false
                }
            }

        case actions.type.UPDATE_SELECTED_OBJECT:
            return {
                ...state,
                ...{
                    selected_object: action.payload.selected_object
                }
            }

        // select event 
        case actions.type.LOAD_LIST_SELECTED_EVENT:
            return state

        case actions.type.SHOW_MODAL_SELECT_EVENT:
            return {
                ...state,
                ...{
                    modalSelectEventState: true
                }
            }

        case actions.type.DISMISS_MODAL_SELECT_EVENT:
            return {
                ...state,
                ...{
                    modalSelectEventState: false
                }
            }

        case actions.type.UPDATE_SELECTED_EVENT:
            return {
                ...state,
                ...{
                    selected_event: action.payload.selected_event
                }
            }

        // select report 
        case actions.type.LOAD_LIST_SELECTED_REPORT:
            return state

        case actions.type.SHOW_MODAL_SELECT_REPORT_LOWER_TIER:
            return {
                ...state,
                ...{
                    modalSelectReportLowerTierState: true
                }
            }

        case actions.type.DISMISS_MODAL_SELECT_REPORT_LOWER_TIER:
            return {
                ...state,
                ...{
                    modalSelectReportLowerTierState: false
                }
            }

        case actions.type.UPDATE_SELECTED_REPORT_LOWER_TIER:
            return {
                ...state,
                ...{
                    selected_report: action.payload.selected_report
                }
            }

        case actions.type.SEND_CURRENT_REPORT:
            return state

        default:
            return state
    }

}

export default reportReducer
